module.exports = `fragment latest_news on Contentstack_latest_news {
    latest_news_hide_while_paginating
    latest_news_heading
    latest_news_enabled
  }`;